import moment from 'moment'
import http from '../http/http';
import URL from '../constant/URL';
import TYPE from '../constant/TYPE';

const { PM_INFO, PM_INFO_EN } = URL;
const { CODE } = URL.API;

// 메인 공지사항 API
export const pmInfoNoticeAPI = async (locale = 'KO', channelCode = '') => {
  let result = null;
  let url = `${PM_INFO}?${new Date()}`

  if(locale.toLowerCase() === 'en' && channelCode === TYPE.CHANNEL.GLOBAL01) url = `${PM_INFO_EN}?${new Date()}`;
  // console.log("url", url);

  await http.request({
    url,
    type: http.TYPE.XML,
    success: (resp) => {
      let notice = { noticeFlag: false, message: '' };
      
      // const CURRENT_TIME = Number(moment(new Date()).format('YYYYMMDDHHmm'));
      const NOTICE_FROM_TIME = resp.querySelector("notice_fromTime");
      const NOTICE_TO_TIME = resp.querySelector("notice_toTime");
      const JOB_FROM_TIME = resp.querySelector('fromTime');
      const JOB_TO_TIME = resp.querySelector('toTime');
      
      if (NOTICE_FROM_TIME && NOTICE_TO_TIME) {
        
        const noticeStartTime = Number(`${NOTICE_FROM_TIME?.getAttribute("day" )}${NOTICE_FROM_TIME?.getAttribute("starttime")}`);
        const noticeEndTime = Number(`${NOTICE_TO_TIME?.getAttribute("day")}${NOTICE_TO_TIME?.getAttribute("endtime")}`);
        const jobStartTime = Number(`${JOB_FROM_TIME?.getAttribute("day")}${JOB_FROM_TIME?.getAttribute("starttime")}`);
        const jobEndTime = Number(`${JOB_TO_TIME?.getAttribute("day")}${JOB_TO_TIME?.getAttribute("endtime")}`);
        const noticeMessage = resp.querySelector("title")?.getAttribute("txt");
        const jobMessage = resp.querySelector("content")?.getAttribute("txt");

        const utcNoticeStartTime = Number(moment(noticeStartTime, 'YYYYMMDDHHmm').utc().format('YYYYMMDDHHmm'));
        const utcNoticeEndTime = Number(moment(noticeEndTime, 'YYYYMMDDHHmm').utc().format('YYYYMMDDHHmm'));
        const utcJobStartTime = Number(moment(jobStartTime, 'YYYYMMDDHHmm').utc().format('YYYYMMDDHHmm'));
        const utcJobEndTime = Number(moment(jobEndTime, 'YYYYMMDDHHmm').utc().format('YYYYMMDDHHmm'));

        const UTC_CURRENT_TIME = Number(moment().utc().format('YYYYMMDDHHmm'))

        // console.log({ noticeStartTime, noticeEndTime, jobStartTime, jobEndTime });
        // console.log({ utcNoticeStartTime, utcNoticeEndTime, utcJobStartTime, utcJobEndTime });
        // console.log({ CURRENT_TIME, UTC_CURRENT_TIME });
        // console.log(moment(noticeStartTime, 'YYYYMMDDHHmm' ));


        if (utcJobStartTime <= UTC_CURRENT_TIME && utcJobEndTime >= UTC_CURRENT_TIME) {
          notice = {
            ...notice,
            jobMessage,
            noticeAlert: true,
          };
        }

        if (utcNoticeStartTime <= UTC_CURRENT_TIME && utcNoticeEndTime >= UTC_CURRENT_TIME) {
          notice = {
            ...notice,
            noticeMessage,
            noticeFlag: true
          };
        }

        // alert(JSON.stringify({
        //   noticeStartTime,
        //   noticeEndTime,
        //   jobStartTime,
        //   jobEndTime,
        //   ...notice
        // }))
        
        result = {
          noticeStartTime,
          noticeEndTime,
          jobStartTime,
          jobEndTime,
          ...notice
        };

        // console.log("result", result);
      }
    },
    error: (error) => { throw error }
  });
  return result;
}

// 공통코드 조회 
export const commonCodeListAPI = async (upCd) => {
  let result = null;
  await http.request({
    url: `${CODE}/${upCd}/language/KO`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });

  return result;
}

// Wpin 복호화 
export const wpinDeAPI = async (data) => {
  let result = null;
  await http.request({
    url: URL.API.WPIN_DE,
    method: http.METHOD.POST,
    data,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });

  return result;
}

export const localAPI = async () => {
  let result = null;
  await http.request({
    url: `${process.env.REACT_APP_API_URL}/api/locale/ko-KR`,
    method: http.METHOD.PUT,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });

  return result;
}

export const getGeoIPAPI = async (data) => {
  let result = null;
  await http.request({
    url: URL.API.GEO_IP,
    method: http.METHOD.POST,
    data,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });
  
  return result;
}